// Purpose: Stock Opname reducer — handles product options and stock opname check state
// Caller: rootReducer (store/reducers/index.js)
// Dependencies: store/actionTypes/stockOpname
// Main Functions: stockOpnameReducer
// Side Effects: none (pure Redux reducer)

import * as Type from "store/actionTypes/stockOpname";

const emptyData = {
  total: {
    totalQty: 0,
    totalCapital: 0,
    totalPricePerItem: 0,
    totalDiscount: 0,
    totalPlatformFee: 0,
    totalAmount: 0,
    totalProfit: 0,
  },
  list: [],
  detail: [],
};

const initialState = {
  isLoading: false,
  isError: false,
  message: [],
  productOptions: [],
  data: { ...emptyData },
};

const stockOpnameReducer = (state = initialState, action) => {
  switch (action.type) {
    case Type.STOCK_OPNAME_REQUEST:
      return { ...state, isLoading: true, isError: false, message: [] };
    case Type.GET_PRODUCT_OPTIONS_SUCCESS:
      return { ...state, isLoading: false, productOptions: action.payload };
    case Type.GET_PRODUCT_OPTIONS_ERROR:
      return { ...state, isLoading: false, isError: true, message: action.payload };
    case Type.GET_STOCK_OPNAME_CHECK_SUCCESS:
      return { ...state, isLoading: false, data: action.payload };
    case Type.GET_STOCK_OPNAME_CHECK_ERROR:
      return { ...state, isLoading: false, isError: true, message: action.payload };
    case Type.STOCK_OPNAME_RESET:
      return { ...initialState };
    default:
      return state;
  }
};

export default stockOpnameReducer;
